import { render, staticRenderFns } from "./ScrapModal.vue?vue&type=template&id=fe474c2a&scoped=true&"
import script from "./ScrapModal.vue?vue&type=script&lang=js&"
export * from "./ScrapModal.vue?vue&type=script&lang=js&"
import style0 from "./ScrapModal.vue?vue&type=style&index=0&id=fe474c2a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe474c2a",
  null
  
)

export default component.exports